import EmailStep from '../../steps/EmailStep';
import { OnboardingNodeType, OnboardingStepType } from '../../steps/types';
import { OnboardingNode } from '../../types';

export const EMAIL_NODE: OnboardingNode = {
  index: 0,
  key: OnboardingNodeType.EMAIL,
  options: { countsTowardProgressBar: true, hideErrorToast: true },
  elements: [
    {
      uid: OnboardingStepType.EMAIL,
      component: (
        <EmailStep
          withGreeting
          uid={OnboardingStepType.EMAIL}
          nodeType={OnboardingNodeType.EMAIL}
          displayName="Name & Email"
          actionButtonText="Continue"
          showEmailDetailsBulletPoint={false}
          showProvideEmailPrompt={true}
        />
      )
    }
  ]
};
